

import { Component, Vue } from "vue-property-decorator";
import { Utils } from "@/services/utils";
@Component
export default class FilterSelectBox extends Vue {
  utilService = new Utils();
  filterShaten(options: any, search: any) {
    return this.utilService.filterSelectBoxMethod(search, "shatenCd", options);
  }

  filterGroup(options: any, search: any) {
    return this.utilService.filterSelectBoxMethod(search, "groupCd", options);
  }

  getShatenLabel(option: any) {
    if (option.shatenCd) {
      return option.kaishaNm + '(' + option.shatenCd + ')';
    }
    return "";
  }
}
